/*
 * yojo-context.js — Issue #5 · Principle P5 (context must persist)
 *
 * Records the user's last shopping surface (PDP or collection) into
 * sessionStorage["yojo:lastShop"]. Cart drawer + cart page + empty-cart
 * "continue shopping" CTAs read this back via [data-yojo-continue-shopping]
 * and rewrite their href so users return to where they were, not to the
 * generic /collections/all dump-zone.
 *
 * Liquid fallback (when sessionStorage is empty / disabled): /collections
 * (the curated catalog feed). Never /collections/all.
 *
 * Sprint 1 scope rules: behavior-only, single asset-level helper, no new
 * sections or components.
 */

(function () {
  'use strict';

  var KEY = 'yojo:lastShop';

  // 1. Write — on PDP / collection page load, record this URL.
  try {
    var path = window.location.pathname;
    var search = window.location.search || '';
    // Match: /products/<h>  OR  /collections/<h>  OR  /collections/<h>/products/<h>
    // Exclude: the all-products dump (/collections/all), the cart, search, pages, policies, root.
    // 2026-09-03 (A3-04 / T03): collections only. A PDP used to be recorded
    // too, so "המשיכו לקנות" in the cart re-opened the product the shopper had
    // just left — a link that does nothing. A PDP visit now leaves the last
    // collection in place; with none recorded the CTAs keep /pages/browse.
    var isShop = /^\/collections\/[^/]+\/?$/.test(path)
      && !/^\/collections\/all(\/|$)/.test(path);
    if (isShop) {
      sessionStorage.setItem(KEY, path + search);
    }
  } catch (e) { /* sessionStorage disabled — silent */ }

  // 2. Read — at DOMContentLoaded, override hrefs on every continue-shopping CTA.
  function applyOverride() {
    try {
      var last = sessionStorage.getItem(KEY);
      if (!last || !/^\/collections\//.test(last)) return;
      document.querySelectorAll('[data-yojo-continue-shopping]').forEach(function (a) {
        a.setAttribute('href', last);
      });
    } catch (e) { /* silent */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyOverride);
  } else {
    applyOverride();
  }

  // 3. Re-apply override after AJAX cart refresh — the cart drawer's HTML
  // gets replaced after every add (replaceChildren via component-product-form
  // and yojo-pdp). The new continue-shopping link inside the refreshed cart
  // form needs the override too.
  document.addEventListener('cart:updated', applyOverride);
})();
